// src/components/common/LoadingSpinner.js
import React from 'react';

const LoadingSpinner = ({ size = 'medium', message = 'Loading...', centered = true }) => {
    const sizeClasses = {
        small: 'spinner-sm',
        medium: 'spinner-md',
        large: 'spinner-lg'
    };

    return (
        <div className={`loading-container ${centered ? 'centered' : ''}`}>
            <div className={`spinner ${sizeClasses[size]}`}></div>
            {message && <p className="loading-message">{message}</p>}

            <style jsx>{`
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: var(--spacing-md);
        }

        .loading-container.centered {
          justify-content: center;
          min-height: 200px;
        }

        .spinner {
          border: 3px solid var(--light-color);
          border-top: 3px solid var(--primary-color);
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .spinner-sm {
          width: 20px;
          height: 20px;
          border-width: 2px;
        }

        .spinner-md {
          width: 40px;
          height: 40px;
          border-width: 3px;
        }

        .spinner-lg {
          width: 60px;
          height: 60px;
          border-width: 4px;
        }

        .loading-message {
          color: var(--text-light);
          font-size: 0.9rem;
          margin: 0;
          text-align: center;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

export default LoadingSpinner;